import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const partnersLogos = [
  "https://tse1.mm.bing.net/th/id/OIP.50Wo_iUaCCxyWO4m_ffmoAHaCS?rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://image.pngaaa.com/360/3741360-middle.png",
  "https://www.tricitypackersmovers.in/assets/img/tricity-pm-logo.png",
  "https://tse1.mm.bing.net/th/id/OIP.oXL4ySLf8faxGNx2Ps5DSgHaE7?w=770&h=513&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://tse2.mm.bing.net/th/id/OIP.s02GfzN6cRo73O5GnPyDrgHaEv?w=500&h=320&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://tse1.mm.bing.net/th/id/OIP.VqkmCtL1pfbJfNhj-WPDtgAAAA?w=320&h=320&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://tse4.mm.bing.net/th/id/OIP.0f3TkoudwXz8nmMaaw6mogHaDm?w=1845&h=899&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://th.bing.com/th/id/R.a572afa4c00fa21b19f3a38190e9597e?rik=c6FgD6s5tD4Pgg&riu=http%3a%2f%2flogisticsmovers.com%2fimages%2flogisticsmovers.png&ehk=lKkjvX4HK27UIapGyffGGIKUw2Fa4bLmoytuQy1clds%3d&risl=&pid=ImgRaw&r=0",
  "https://tse4.mm.bing.net/th/id/OIP.LLPoyuJxvoTA-EED65iQWgAAAA?w=300&h=69&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://quickmoverslogistics.com/wp-content/uploads/2022/06/Logo.png",
  "https://th.bing.com/th/id/R.2413de78f82b14ec85eadc04bbfc27a2?rik=Ql4iDchdloOQaw&riu=http%3a%2f%2fjainpackersmovers.com%2fwp-content%2fuploads%2f2020%2f06%2flogo12.png&ehk=IoZAvw74ZM4owL6kOda9Shx9ru3%2bfkeLS6jvyTaiHLo%3d&risl=&pid=ImgRaw&r=0",
  "https://packersmoversintl.com/wp-content/uploads/2024/01/Logo-1.png",
  "https://tse4.mm.bing.net/th/id/OIP.wj2Cnz3fXULlkLtx_ly_VAHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://www.riyadhmoverspackers.com/wp-content/uploads/2023/05/cropped-Riyadh-Movers-Packers-22.png",
  "https://tse3.mm.bing.net/th/id/OIP.Bq4l_WUj-LKUqeh-kBVACQHaCZ?w=1280&h=414&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://th.bing.com/th/id/OIP.ZJx1-OdtSVI5pjNNd5udSQHaHN?o=7rm=3&rs=1&pid=ImgDetMain&o=7&rm=3",
  "https://tse3.mm.bing.net/th/id/OIP.3Ay0Gh3bfWnavcRy2xLOowHaHa?w=500&h=500&rs=1&pid=ImgDetMain&o=7&rm=3",
];

const Partners = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="bg-light text-dark py-16 px-4 md:px-10">
      {/* Hero */}
      <section className="text-center mb-16">
        <motion.h1
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-5xl font-bold text-primary mb-4"
        >
          Our Trusted Partners
        </motion.h1>
        <motion.p
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-secondary max-w-3xl mx-auto text-lg"
        >
          We collaborate with top logistics companies, transport providers, and
          infrastructure experts to deliver seamless experiences for every move.
        </motion.p>
      </section>

      {/* Logo Scroller */}
      <section className="overflow-hidden whitespace-nowrap relative">
        <div className="absolute left-0 top-0 h-full w-full bg-gradient-to-r from-light via-transparent to-light z-10" />
        <motion.div
          className="flex gap-16 animate-scroll-slow"
          initial={{ x: 0 }}
          animate={{ x: "-100%" }}
          transition={{ repeat: Infinity, duration: 60, ease: "linear" }}
        >
          {[...partnersLogos, ...partnersLogos].map((logo, i) => (
            <img
              key={i}
              src={logo}
              alt={`Partner ${i}`}
              className="h-12 md:h-14  transition duration-300"
              //   grayscale hover:grayscale-0
            />
          ))}
        </motion.div>
      </section>

      {/* Why Collaborate */}
      <section className="mt-24 text-center max-w-5xl mx-auto">
        <motion.h2
          className="text-3xl font-bold text-primary mb-6"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Why Partner With Tiranga Express?
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-10 text-left">
          <motion.div
            className="bg-white rounded-xl shadow p-6"
            whileHover={{ scale: 1.03 }}
          >
            <h4 className="text-xl font-bold text-dark mb-2">
              Expand Your Reach
            </h4>
            <p className="text-neutral-900">
              Connect with thousands of customers looking for trusted logistics
              providers daily.
            </p>
          </motion.div>
          <motion.div
            className="bg-white rounded-xl shadow p-6"
            whileHover={{ scale: 1.03 }}
          >
            <h4 className="text-xl font-bold text-dark mb-2">
              Boost Visibility
            </h4>
            <p className="text-neutral-900">
              Showcase your services and get featured in our premium listings.
            </p>
          </motion.div>
          <motion.div
            className="bg-white rounded-xl shadow p-6"
            whileHover={{ scale: 1.03 }}
          >
            <h4 className="text-xl font-bold text-dark mb-2">
              Seamless Onboarding
            </h4>
            <p className="text-neutral-900">
              Easy registration, profile setup, and integration with our booking
              system.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-primary text-white py-12 mt-20 rounded-xl text-center">
        <h2 className="text-3xl font-bold mb-3">Become a Tiranga Partner</h2>
        <p className="max-w-xl mx-auto mb-6">
          Join our growing network of professional movers, transporters, and
          logistics experts across India.
        </p>
        <button
          onClick={handleToggleModal}
          className="bg-white text-primary font-semibold px-6 py-3 rounded hover:bg-light transition"
        >
          Register as Partner
        </button>
      </section>

      {/* Modal Form */}
      {/* <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center px-4 py-80"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-xl shadow-xl p-8 max-w-xl w-full relative"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
            >
              <button
                onClick={handleToggleModal}
                className="absolute top-4 right-4 text-xl text-gray-500 hover:text-red-500"
              >
                &times;
              </button>
              <h3 className="text-2xl font-bold text-primary mb-6">
                Partner Registration
              </h3>
              <form className="grid gap-4">
                <div>
                  <label className="font-semibold">Company Name</label>
                  <input
                    type="text"
                    placeholder="Your logistics company name"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                    required
                  />
                </div>

                <div>
                  <label className="font-semibold">Contact Person</label>
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                    required
                  />
                </div>

                <div>
                  <label className="font-semibold">Email Address</label>
                  <input
                    type="email"
                    placeholder="example@email.com"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                    required
                  />
                </div>

                <div>
                  <label className="font-semibold">Phone Number</label>
                  <input
                    type="tel"
                    placeholder="+91 XXXXX XXXXX"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                    required
                  />
                </div>

                <div>
                  <label className="font-semibold">Service Category</label>
                  <select className="w-full border border-gray-300 rounded px-4 py-2 mt-1">
                    <option>Select service type</option>
                    <option>Packers & Movers</option>
                    <option>Car Transport</option>
                    <option>Warehouse</option>
                    <option>Cargo & Freight</option>
                    <option>Bike Transport</option>
                    <option>Pet Relocation</option>
                    <option>International Movers</option>
                  </select>
                </div>

                <div>
                  <label className="font-semibold">Business Location</label>
                  <input
                    type="text"
                    placeholder="City, State"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                  />
                </div>

                <div>
                  <label className="font-semibold">Upload Documentation</label>
                  <input
                    type="file"
                    className="w-full border border-gray-300 rounded px-4 py-2 mt-1"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Upload company registration, GST certificate, or license.
                  </p>
                </div>

                <button
                  type="submit"
                  className="bg-primary text-white px-6 py-2 rounded hover:bg-[#063a6f] transition mt-4"
                >
                  Submit Application
                </button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}
      <AnimatePresence>
  {isOpen && (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-6 md:p-10 relative overflow-y-auto max-h-[90vh]"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        {/* Close button */}
        <button
          onClick={handleToggleModal}
          className="absolute top-3 right-4 text-3xl text-gray-600 hover:text-red-500"
        >
          &times;
        </button>

        {/* Modal Title */}
        <h3 className="text-2xl md:text-3xl font-bold text-primary mb-6 text-center">
          Partner Registration
        </h3>

        <form className="space-y-5">
          <div>
            <label className="font-semibold text-dark block">Company Name</label>
            <input
              type="text"
              placeholder="Your logistics company name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary"
              required
            />
          </div>

          <div>
            <label className="font-semibold text-dark block">Contact Person</label>
            <input
              type="text"
              placeholder="Full Name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary"
              required
            />
          </div>

          <div>
            <label className="font-semibold text-dark block">Email Address</label>
            <input
              type="email"
              placeholder="example@email.com"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary"
              required
            />
          </div>

          <div>
            <label className="font-semibold text-dark block">Phone Number</label>
            <input
              type="tel"
              placeholder="+91 XXXXX XXXXX"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary"
              required
            />
          </div>

          <div>
            <label className="font-semibold text-dark block">Service Category</label>
            <select className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary">
              <option>Select service type</option>
              <option>Packers & Movers</option>
              <option>Car Transport</option>
              <option>Warehouse</option>
              <option>Cargo & Freight</option>
              <option>Bike Transport</option>
              <option>Pet Relocation</option>
              <option>International Movers</option>
            </select>
          </div>

          <div>
            <label className="font-semibold text-dark block">Business Location</label>
            <input
              type="text"
              placeholder="City, State"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1 focus:outline-primary"
            />
          </div>

          <div>
            <label className="font-semibold text-dark block">Upload Documentation</label>
            <input
              type="file"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
            />
            <p className="text-xs text-gray-500 mt-1">
              Upload company registration, GST certificate, or license.
            </p>
          </div>

          <div className="text-center pt-4">
            <button
              type="submit"
              className="bg-primary hover:bg-[#00366d] text-white px-6 py-3 rounded-lg font-semibold shadow-lg"
            >
              Submit Application
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

    </div>
  );
};

export default Partners;
